import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureProductionLogging } from './utils/configureProductionLogging';
import { installDomTranslationGuard } from './utils/domTranslationGuard';
import { installUiDictionary } from './utils/uiDictionary';
import { applyInitialOwnLang } from './utils/appLang';

configureProductionLogging();
/* 번역 도구가 화면 구조를 바꿔도 React 가 화면 전체를 지우지 않게(2026-10-09 배송 상세 «검은 화면») */
installDomTranslationGuard();
/* 번역 서비스(Weglot)가 새 글자를 못 번역하는 동안 쓰는 코드 안 번역 사전(2026-10-09) — 언어가 영어·태국어·베트남어일 때만 동작 */
/* Weglot 을 끄고 연 시험(?weglot=off)이면 시작 언어를 자체 저장값으로 — 켜 있으면 아무것도 안 한다(2026-11-05) */
applyInitialOwnLang();
installUiDictionary();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
